import { render, staticRenderFns } from "./TaxInvoiceRequestPop.vue?vue&type=template&id=16b38977&scoped=true"
import script from "./TaxInvoiceRequestPop.vue?vue&type=script&lang=js"
export * from "./TaxInvoiceRequestPop.vue?vue&type=script&lang=js"
import style0 from "./TaxInvoiceRequestPop.vue?vue&type=style&index=0&id=16b38977&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b38977",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16b38977')) {
      api.createRecord('16b38977', component.options)
    } else {
      api.reload('16b38977', component.options)
    }
    module.hot.accept("./TaxInvoiceRequestPop.vue?vue&type=template&id=16b38977&scoped=true", function () {
      api.rerender('16b38977', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settle/popup/TaxInvoiceRequestPop.vue"
export default component.exports